import api from './apiService';

export type RecipeSearchSource = 'name' | 'content' | 'chat';

export type RecipeSearchResult = {
  id: number;
  name: string;
  updatedAt: string;
  matchedSources: RecipeSearchSource[];
  snippet: {
    source: RecipeSearchSource;
    text: string;
    sender?: 'user' | 'ai';
  };
};

export type RecipeSearchResponse = {
  results: RecipeSearchResult[];
  total: number;
  nextOffset: number | null;
};

export const searchRecipes = async (
  query: string,
  offset: number,
  limit: number,
  signal: AbortSignal
): Promise<RecipeSearchResponse> => {
  const response = await api.get<RecipeSearchResponse>('recipes/search', {
    params: { q: query, offset, limit },
    signal,
  });
  return response.data;
};
